const getReasonsCall = (formatMessage) => ({
  1: formatMessage({ id: 'getReasonsCall.1', defaultMessage: 'Je souhaite des conseils' }),
  2: formatMessage({ id: 'getReasonsCall.2', defaultMessage: 'Je souhaite engager un avocat' }),
  3: formatMessage({
    id: 'getReasonsCall.3',
    defaultMessage: "J'ai besoin de faire rédiger un document",
  }),
  4: formatMessage({ id: 'getReasonsCall.4', defaultMessage: 'Je rencontre un litige' }),
  5: formatMessage({
    id: 'getReasonsCall.5',
    defaultMessage: "Je ne sais pas ce dont j'ai besoin",
  }),
})

export default getReasonsCall
